<div class="my-news-component-container">
    <ng-template #gotoLink>
        <app-action-link *ngIf="newsCenterUrl" [href]="newsCenterUrl" [target]="'blank'">
            <span i18n="news see all news link@@news-see-all-news-link">Go to the news center</span>
            <i class="ml-2 ms-Icon ms-Icon--ArrowUpRight" aria-hidden="true"></i>
        </app-action-link>
        <app-action-router-link *ngIf="!newsCenterUrl" [actionRouterLink]="'../pages/news'" [buttonClass]="'align-middle'">
            <span i18n="news see all news link@@news-see-all-news-link">Go to the news center</span>
            <i class="ml-2 ms-Icon ms-Icon--ArrowUpRight" aria-hidden="true"></i>
        </app-action-router-link>
    </ng-template>

    <div class="d-none d-md-block float-md-right mt-1">
        <ng-container *ngTemplateOutlet="gotoLink"></ng-container>
    </div>
    <h2 i18n="my news title@@my-news-title" class="widget-header h4 my-news-title">Your news</h2>
    <h3 class="text-muted h6" i18n="news my news sub title@@news-my-news-sub-title">Here you'll find the latest posts in your personal feed. Update your selected channels on your <a routerLink="/settings" class="settings-link action">settings page</a>. When you click on a post, it will open in a new tab. You can navigate back here at any time by closing or switching the tab.</h3>
    <div class="d-block d-md-none mt-2 mt-md-0">
        <ng-container *ngTemplateOutlet="gotoLink"></ng-container>
    </div>

    <div class="my-news-item-container">
        <div *ngIf="personalNewsItems$ | async as personalNewsItems; else innerLoading">

            <div *ngIf="personalNewsItems && personalNewsItems.length > 0">
                <app-news-card-list [personalNewsItems]='personalNewsItems'></app-news-card-list>
            </div>

            <div *ngIf="personalNewsItems && personalNewsItems.length === 0">
                <app-text-placeholder>
                    <p i18n="my news none found@@my-news-none-found">No news could be found according to your channel selections.</p>
                </app-text-placeholder>
            </div>

            <div *ngIf="loading" class="mt-4">
                <div *ngIf="errorSubject$ | async as err; else innerLoading">
                    <app-error-templates [error]="err.status" [componentName]="componentName"></app-error-templates>
                </div>
            </div>
        </div>
    </div>

    <ng-template #innerLoading>
        <div class="mt-4">
            <app-widget-placeholder></app-widget-placeholder>
        </div>
    </ng-template>

    <div class="row justify-content-center mt-4" *ngIf="fetchedAmountOfNews > amountOfNewsToDisplayCurrently && !loading && numberOfShowMoreClicks < maxNumberOfShowMore else linkToNewsCenter">
        <div class="col-auto">
            <button mat-flat-button color="accent" class="news-show-more-btn" (click)="showMoreNews()"><span i18n="my news show more@@my-news-show-more">Show more news</span><i class="ml-2 ms-Icon ms-Icon--ChevronDown" aria-hidden="true"></i></button>
        </div>
    </div>
    <div class="row justify-content-center mt-4" *ngIf="fetchedAmountOfNews > amountOfNewsToDisplayCurrently && !loading && numberOfShowMoreClicks === maxNumberOfShowMore">
        <div class="col-auto">
            <button mat-flat-button color="accent" class="news-show-less-btn" (click)="showLessNews()"><span i18n="my news show more@@my-news-show-less">Show less news</span><i class="ml-2 ms-Icon ms-Icon--ChevronUp" aria-hidden="true"></i></button>
        </div>
    </div>

    <ng-template #linkToNewsCenter>
        <div class="col-auto mt-4 text-center" *ngIf="!loading">
            <span *ngIf="newsCenterUrl" i18n="@@more-news-in-news-center">For older news, open <app-action-link [href]="newsCenterUrl" [target]="'blank'">News Center</app-action-link></span>
            <span *ngIf="!newsCenterUrl" i18n="@@more-news-in-internal-news-center">For older news, open <app-action-router-link [routerLink]="'../pages/news'">News Center</app-action-router-link></span>
        </div>
    </ng-template>
</div>
